import React from 'react';
import logoSaneamento from '../../assets/images/logo_saneamento_consolacao.png';
import './Inicio.css';
import ImagemPlanejamento from '../../assets/images/imagem_produtos.png'

const Inicio = () => {
  return (
    <div>
      <div className="cover-section">
        <div className="cover-logo-wrapper">
          <img
            src={logoSaneamento}
            alt="Logotipo Saneamento Consolação"
            className="cover-logo"
          />
        </div>
      </div>

      <div className="content-one">
        <div className="middle-content-container">
          <h2>
            Sobre o Plano de Saneamento
          </h2>
          <p>
            O Plano Municipal de Saneamento Básico (PMSB) é o instrumento que orienta as ações do município para garantir serviços de abastecimento de água, esgotamento sanitário, manejo de resíduos sólidos e drenagem urbana de forma eficiente e sustentável. Ele define metas, prioridades e investimentos necessários para melhorar a qualidade de vida da população e proteger o meio ambiente. Sua importância está em planejar o desenvolvimento da cidade com base em informações técnicas e na participação da comunidade, promovendo saúde pública, bem-estar social e o uso responsável dos recursos naturais. O PMSB é previsto na Política Nacional de Saneamento Básico e no Novo Marco Legal do Saneamento (Leis nº 11.445/2007 e nº 14.026/2020).
          </p>
        </div>
      </div>

      <div className="content-two">
        <div className="highlight-section-container">
          <h2>
            Participação social
          </h2>
          <p>
          A participação social nos Planos de Saneamento é garantida por lei e deve ocorrer por meio de audiências, consultas públicas e ampla divulgação do conteúdo produzido, assegurando que o plano reflita as necessidades reais da população e promova transparência, controle social e gestão democrática dos serviços públicos. É por meio das opiniões, sugestões e experiências dos moradores que o plano pode refletir as reais necessidades da comunidade. Participe!
          </p>
        </div>
      </div>

      <div className="content-three">
        <div className="additional-section-container">
          <div className="planning-image-wrapper"></div>
             <img src={ImagemPlanejamento} alt="Descrição da imagem" className="planning-image" />
          </div>
      </div>
    </div>
  );
};

export default Inicio;
